import { render, staticRenderFns } from "./RosOnboarding.vue?vue&type=template&id=900007c6&"
import script from "./RosOnboarding.vue?vue&type=script&lang=js&"
export * from "./RosOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('900007c6')) {
      api.createRecord('900007c6', component.options)
    } else {
      api.reload('900007c6', component.options)
    }
    module.hot.accept("./RosOnboarding.vue?vue&type=template&id=900007c6&", function () {
      api.rerender('900007c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/RosOnboarding.vue"
export default component.exports